type LogLevel = "debug" | "info" | "warn" | "error" | "webhook";

class Logger {
  private shouldLog: (level: LogLevel) => boolean;

  constructor(shouldLog: (level: LogLevel) => boolean) {
    this.shouldLog = shouldLog;
  }

  debug(...args: any[]) {
    if (this.shouldLog("debug")) {
      console.log("🔍", ...args);
    }
  }

  info(...args: any[]) {
    if (this.shouldLog("info")) {
      console.log("ℹ️", ...args);
    }
  }

  warn(...args: any[]) {
    if (this.shouldLog("warn")) {
      console.warn("⚠️", ...args);
    }
  }

  error(...args: any[]) {
    if (this.shouldLog("error")) {
      console.error("❌", ...args);
    }
  }

  // 专门用于 PayPro webhook 的详细日志
  webhook(type: string, data?: any) {
    if (this.shouldLog("webhook")) {
      console.log(`🔄 [PayPro Webhook][${type}]`, data || "");
    }
  }
}

/**
 * 导出的 logger 用于前端日志打印，生产环境只输出 warn 和 error 级别的日志
 */
export const logger = (() => {
  return new Logger((level) => {
    const isDev = process.env.NODE_ENV === "development";
    if (isDev) return true;
    // 生产环境只输出 warn 和 error 级别的日志
    return ["warn", "error"].includes(level);
  });
})();

/**
 * 导出的 serverLogger 用于后端日志打印，输出任何级别的日志
 */
export const serverLogger = (() => {
  return new Logger(() => {
    return true;
  });
})();
